export default "__VITE_ASSET__COT5i8n0__"